import React, { useState, useRef, useContext } from 'react'
import { Box, Button, TextField, Typography, CircularProgress } from '@mui/material'
import { ChatContext } from '../../../contexts/ChatContext'
import { LoadingButton } from '@mui/lab'
import { CompChat, Loading, Mensagens, SearchAlert } from '../../Simple'
import { IoChevronBackOutline } from 'react-icons/io5'
import RouterHook from '../../../contexts/RouterHook'
import SendIcon from '@mui/icons-material/Send'
import { HeaderChat } from '../../Complex'
import { io } from 'socket.io-client'
import { stylesDesk } from './stylesChat'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { LocalStorage } from '../../../services'

export default function DesktopChat() {
  const serverRouter = RouterHook()
  const listRef = useRef(null)
  const listChatsRef = useRef(null)
  const { sttChatCtx, actionsChatCtx, loadsChat } = useContext(ChatContext)
  const { userUCtx } = useContext(UsuarioContext)
  const [inputMsg, setInputMsg] = useState('')
  const socket = useRef(null)
  const currentChatId = useRef(null)

  React.useEffect(() => {
    const chatId = sttChatCtx.chat?.idchat
    if (chatId && chatId !== currentChatId.current) {
      if (socket.current) {
        socket.current.disconnect()
      }

      const newSocket = io(import.meta.env.VITE_URL_SOCKET + '/conectar-chat', {
        query: { idChat: chatId },
        transports: ['websocket'],
        secure: true,
      })

      newSocket.on('connect', () => {
        socket.current = newSocket
        currentChatId.current = chatId
        newSocket.emit('entrarChat', { idchat: chatId, gestor: false })
        // newSocket.on('message', mensagens => {
        //   // console.log('Mensagem emitida', mensagens)
        // })
        newSocket.on('novaMensagem', mensagem => {
          //console.log('Nova mensagem recebida', mensagem)
          actionsChatCtx.atualizarMensagem(mensagem)
          actionsChatCtx.handleLoadChat('sendMsg', false)
        })
        // newSocket.on('error', erro => {
        //   //console.log('Erro no socket', erro)
        // })
        newSocket.on('disconnect', () => {})
      })

      newSocket.on('disconnect', () => {})

      return () => {
        if (socket.current) {
          socket.current.emit('sairChat', { idchat: chatId, gestor: false })
          socket.current.disconnect()
          socket.current = null
          currentChatId.current = null
        }
      }
    } else if (!chatId && currentChatId.current) {
      if (socket.current) {
        socket.current.emit('sairChat', { idchat: currentChatId.current, gestor: false })
        socket.current.disconnect()
        currentChatId.current = null
        socket.current = null
      }
    }
  }, [sttChatCtx.chat])

  const handleSendMessage = () => {
    if (socket.current && inputMsg.trim()) {
      actionsChatCtx.handleLoadChat('sendMsg', true)
      socket.current.emit('enviarMensagem', {
        idchat: sttChatCtx.chat.idchat,
        modo_caixa_entrada: sttChatCtx.modeChat === 'agendamentos' ? 'modo_pedido' : 'modo_empresa',
        mensagem: {
          texto: inputMsg,
          enviadoPor: userUCtx.usuario.nome,
          criadaPorAdmin: false,
        },
      })
      setInputMsg('')
    }
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleSendMessage()
    } else if (event.key === 'Escape') {
      setInputMsg('')
    }
  }

  React.useEffect(() => {
    const chatSelected = LocalStorage.get('chat-selected')

    if (chatSelected) {
      if (chatSelected.mode === 'agendamentos') {
        if (sttChatCtx.chatMNLP || !sttChatCtx.pesquisedAgends) {
          actionsChatCtx.BuscarChatAgendamentos(true)
        } else {
          actionsChatCtx.AbrirChatPedido(chatSelected.id)
        }
      } else {
        if (sttChatCtx.chatMNLE || !sttChatCtx.pesquisedDirects) {
          actionsChatCtx.BuscarChatDiretos(true)
        } else {
          actionsChatCtx.AbrirChatDireto(chatSelected.id)
        }
      }
    } else if (sttChatCtx.modeChat === 'agendamentos') {
      actionsChatCtx.BuscarChatAgendamentos(true)
    } else {
      actionsChatCtx.BuscarChatDiretos(true)
    }
  }, [sttChatCtx.modeChat])

  let flagRef = React.useRef(false)
  React.useEffect(() => {
    const handleScroll = () => {
      if (
        listChatsRef.current &&
        listChatsRef.current.scrollTop + listChatsRef.current.clientHeight >=
          listChatsRef.current.scrollHeight - 10
      ) {
        if (
          sttChatCtx.modeChat === 'agendamentos' &&
          !loadsChat.chatPagination &&
          !flagRef.current
        ) {
          if (sttChatCtx.chatsAgends.length < sttChatCtx.maxScroll) {
            flagRef.current = true
            actionsChatCtx.BuscarChatAgendamentos(false).then(() => {
              flagRef.current = false
            })
          }
        } else if (
          sttChatCtx.modeChat === 'diretos' &&
          !loadsChat.chatPagination &&
          !flagRef.current
        ) {
          if (sttChatCtx.chatsDirects.length < sttChatCtx.maxScroll) {
            flagRef.current = true
            actionsChatCtx.BuscarChatDiretos(false).then(() => {
              flagRef.current = false
            })
          }
        }
      }
    }

    const currentRef = listChatsRef.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handleScroll)
    }
    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handleScroll)
      }
    }
  }, [sttChatCtx.modeChat, loadsChat, sttChatCtx.chatsAgends, sttChatCtx.chatsDirects])

  function ReturnSttPage() {
    actionsChatCtx.handleChatStt('chat', null)
    serverRouter('back')
  }

  React.useEffect(() => {
    if (sttChatCtx.chat && listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight
    }
    window.history.pushState(null, null, window.location.pathname)
    window.addEventListener('popstate', ReturnSttPage)
    return () => window.removeEventListener('popstate', ReturnSttPage)
  }, [sttChatCtx.modeChat, sttChatCtx.chat])

  return (
    <>
      <Box sx={stylesDesk.containPageChat}>
        <Box sx={stylesDesk.containChats}>
          <Box sx={stylesDesk.containHeader}>
            <IoChevronBackOutline
              size={30}
              style={stylesDesk.iconFixed}
              onClick={() => ReturnSttPage()}
            />
            <Typography sx={stylesDesk.titleHeader} variant='h5'>
              Conversas
            </Typography>
          </Box>
          <Box sx={stylesDesk.containBtts}>
            <Button
              fullWidth
              sx={
                sttChatCtx.modeChat === 'agendamentos'
                  ? stylesDesk.btnActive
                  : stylesDesk.btnInactive
              }
              style={{ borderRadius: '7px 0 0 0' }}
              onClick={() =>
                sttChatCtx.modeChat !== 'agendamentos' &&
                !loadsChat.listChat &&
                actionsChatCtx.handleModeChat('agendamentos')
              }
            >
              Agendamentos
            </Button>
            <Button
              fullWidth
              sx={sttChatCtx.modeChat === 'diretos' ? stylesDesk.btnActive : stylesDesk.btnInactive}
              style={{ borderRadius: '0 7px 0 0' }}
              onClick={() =>
                sttChatCtx.modeChat !== 'diretos' &&
                !loadsChat.listChat &&
                actionsChatCtx.handleModeChat('diretos')
              }
            >
              Mensagens Diretas
            </Button>
          </Box>
          <Box sx={stylesDesk.containList} ref={listChatsRef}>
            {loadsChat.listChat ? (
              <div className='contain-loading'>
                <Loading text='Carregando conversas...' />
              </div>
            ) : sttChatCtx.modeChat === 'agendamentos' ? (
              sttChatCtx.chatsAgends.length > 0 ? (
                sttChatCtx.chatsAgends.map((chat, index) => (
                  <React.Fragment key={index}>
                    <CompChat
                      key={index}
                      fotoEmpresa={chat.fotoEmpresa}
                      chat={chat}
                      onClick={() => {
                        if (sttChatCtx.chat?.idchat !== chat.idchat && !loadsChat.chatSelected)
                          actionsChatCtx.SelectChatAgend(chat.idchat)
                      }}
                    />
                    <Box sx={stylesDesk.containLine} />
                  </React.Fragment>
                ))
              ) : (
                <SearchAlert text='Realize um agendamento para iniciar uma conversa.' />
              )
            ) : sttChatCtx.chatsDirects.length > 0 ? (
              sttChatCtx.chatsDirects.map((chat, index) => (
                <React.Fragment key={index}>
                  <CompChat
                    key={index}
                    fotoEmpresa={chat.pedido.empresa.urlFoto + chat.pedido.empresa.foto}
                    chat={chat}
                    onClick={() => {
                      if (sttChatCtx.chat?.idchat !== chat.idchat && !loadsChat.chatSelected)
                        actionsChatCtx.SelectChatDirect(chat.idchat)
                    }}
                  />
                  <Box sx={stylesDesk.containLine} />
                </React.Fragment>
              ))
            ) : (
              <SearchAlert text='Para iniciar uma conversa direta, vá até a página do centro esportivo desejado e inicie uma conversa com o gestor.' />
            )}
            {loadsChat.chatPagination && (
              <div className='contain-loading'>
                <Loading />
              </div>
            )}
          </Box>
        </Box>
        <Box sx={stylesDesk.containChat}>
          {loadsChat.chatSelected ? (
            <div className='contain-loading'>
              <Loading text='Carregando conversa...' />
            </div>
          ) : sttChatCtx.chat !== null ? (
            <>
              <HeaderChat />
              <Box ref={listRef} sx={stylesDesk.containListMensagens}>
                {sttChatCtx.chat.mensagens.map((msg, index) => (
                  <Mensagens key={index} index={index} msg={msg} chat={sttChatCtx.chat} />
                ))}
              </Box>
              <Box sx={stylesDesk.containInputMensagens}>
                <TextField
                  fullWidth
                  hiddenLabel
                  sx={stylesDesk.inputMsg}
                  variant='filled'
                  size='small'
                  placeholder='Digite sua mensagem...'
                  value={inputMsg}
                  onChange={e => setInputMsg(e.target.value)}
                  onKeyDown={handleKeyDown}
                  autoComplete='off'
                />
                <LoadingButton
                  size='small'
                  onClick={handleSendMessage}
                  endIcon={
                    !loadsChat.sendMsg && (
                      <SendIcon sx={{ ...stylesDesk.iconSend, color: 'white' }} />
                    )
                  }
                  loading={loadsChat.sendMsg}
                  loadingIndicator={<CircularProgress size={20} sx={stylesDesk.iconSend} />}
                  variant='contained'
                  sx={
                    inputMsg.length
                      ? stylesDesk.btnSendMsg
                      : { ...stylesDesk.btnSendMsg, backgroundColor: '#d9d9d9' }
                  }
                />
              </Box>
            </>
          ) : (
            <SearchAlert text='Selecione uma conversa para visualizar suas mensagens.' />
          )}
        </Box>
      </Box>
      <Box sx={{ height: '20%', display: 'flex', alignItems: 'center', pb: 1 }}>
        <div
          className='rtz-banner'
          data-rtz-espaco-id='121'
          style={{ width: '728px', height: '90px', overflow: 'hidden' }}
          data-rtz-width='728'
          data-rtz-height='90'
          title='Espaço publicitário'
          data-rtz-display-formato='imagem_video'
          data-rtz-tipo-criativo='360'
          data-rtz-device='desktop'
        ></div>
      </Box>
    </>
  )
}
